import React from "react";
import { formatDate } from "../../../util/functions";



export const Header = () => {
  return (
    <div style={{ width: "100%", marginTop: -20 }}>
      <div style={{ display: "flex", width: "100%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            width: "100%",
          }}
        >
          <div style={{
             display: "flex",
             fontSize: 12,
             fontWeight: "bold",
             width: "50%",
             fontFamily: "arial",
             border: "1px solid hidden",
          }}>
            <div
            >
              <span
                style={{
                  fontSize: 14,
                  textTransform: "uppercase",
                  backgroundColor: "transparent",
                }}
              >
                {`DROIT UTILISATEUR`}
              </span>
            </div>
          </div>
          <div>
            <div>
              <span
                style={{
                  fontSize: 10,
                  backgroundColor: "transparent",
                }}
              >
                {formatDate(new Date)}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginTop: 5, display: 'flex', width: "100%", }}>
        <tr
          style={{
            backgroundColor: "black",
            width: "100%",
            height: 1,
            marginTop: 0.5,
          }}
        />
      </div>
    </div>
  );
};
